import React, { useState, useEffect, useCallback } from 'react';
import {
  Box,
  Typography,
  TextField,
  Grid,
  Button,
  CircularProgress,
  Card,
  CardContent
} from '@material-ui/core';
import { solicitudDetalleService } from '../../services';

const SeccionCuentasBancariasExterior = ({ solicitudId, tipo }) => {
  const [loading, setLoading] = useState(false);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [formData, setFormData] = useState({
    banco: '',
    pais: '',
    numeroCuenta: '',
    swift: ''
  });

  const cargarDatos = useCallback(async () => {
    try {
      setLoading(true);
      setError('');
      const getMethod = tipo === 'individuo'
        ? solicitudDetalleService.getCuentasBancariasExteriorIndividuo
        : solicitudDetalleService.getCuentasBancariasExteriorEmpresa;
      const response = await getMethod(solicitudId);
      if (response) {
        setFormData({
          banco: response.banco || '',
          pais: response.pais || '',
          numeroCuenta: response.numeroCuenta || '',
          swift: response.swift || ''
        });
      }
    } catch (err) {
      setError('Error al cargar las cuentas bancarias del exterior');
    } finally {
      setLoading(false);
    }
  }, [solicitudId, tipo]);

  useEffect(() => {
    cargarDatos();
  }, [cargarDatos]);

  const handleInputChange = (field, value) => {
    setFormData(prev => ({ ...prev, [field]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSaving(true);
    setError('');
    setSuccess('');

    try {
      const datosParaGuardar = {
        solicitudId: parseInt(solicitudId),
        ...formData
      };
      const saveMethod = tipo === 'individuo'
        ? solicitudDetalleService.saveCuentasBancariasExteriorIndividuo
        : solicitudDetalleService.saveCuentasBancariasExteriorEmpresa;
      await saveMethod(datosParaGuardar);
      setSuccess('Datos guardados exitosamente');
      setTimeout(() => setSuccess(''), 3000);
    } catch (err) {
      setError('Error al guardar los datos');
    } finally {
      setSaving(false);
    }
  };

  if (loading) {
    return (
      <Box display="flex" justifyContent="center" p={3}>
        <CircularProgress />
      </Box>
    );
  }

  return (
    <Card>
      <CardContent>
        <Typography variant="h6" gutterBottom>
          Cuentas Bancarias del Exterior
        </Typography>
        {error && (
          <Box p={2} mb={2} style={{ backgroundColor: '#ffebee', color: '#c62828', borderRadius: '4px' }}>
            <Typography variant="body2">{error}</Typography>
          </Box>
        )}
        {success && (
          <Box p={2} mb={2} style={{ backgroundColor: '#e8f5e9', color: '#2e7d32', borderRadius: '4px' }}>
            <Typography variant="body2">{success}</Typography>
          </Box>
        )}
        <form onSubmit={handleSubmit}>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                label="Banco"
                value={formData.banco}
                onChange={(e) => handleInputChange('banco', e.target.value)}
                variant="outlined"
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                label="País"
                value={formData.pais}
                onChange={(e) => handleInputChange('pais', e.target.value)}
                variant="outlined"
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                label="Número de Cuenta"
                value={formData.numeroCuenta}
                onChange={(e) => handleInputChange('numeroCuenta', e.target.value)}
                variant="outlined"
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                label="SWIFT"
                value={formData.swift}
                onChange={(e) => handleInputChange('swift', e.target.value)}
                variant="outlined"
              />
            </Grid>
            <Grid item xs={12}>
              <Button
                type="submit"
                variant="contained"
                color="primary"
                disabled={saving}
              >
                {saving ? <CircularProgress size={20} /> : 'Guardar'}
              </Button>
            </Grid>
          </Grid>
        </form>
      </CardContent>
    </Card>
  );
};

export default SeccionCuentasBancariasExterior;

